import CustomHeader from 'components/ReusableComponents/HeaderTitles'
import BarChartIcon from 'components/ReusableComponents/Icons/BarChart'
import ControlsIcon from 'components/ReusableComponents/Icons/Controls'
import DownloadIcon from 'components/ReusableComponents/Icons/DownloadIcon'
import EditIcon from 'components/ReusableComponents/Icons/Edit'
import FileUploadIcon from 'components/ReusableComponents/Icons/FIleUpload'
import GuestComplianceIcon from 'components/ReusableComponents/Icons/GuestCompliance'
import PopupIcon from 'components/ReusableComponents/Icons/Popup'
import ComplianceOptInChartDialog from 'features/Compliance/ComplianceOptInChartDialog'
import ComplianceOptOutChartDialog from 'features/Compliance/ComplianceOptOutChartDialog'
import UpdateLegalLinksDialog from 'features/Compliance/UpdateLegalLinksDialog'
import UploadConsentListDialog from 'features/Compliance/UploadConsentListDialog'
import UploadConsentLogsDialog from 'features/Compliance/UploadConsentLogsDialog'
import { useInternalAdmin } from 'hooks'
import { useEffect, useState } from 'react'
import complianceApi from 'services/api/compliance'
import { formatNumberAsThousands } from 'utils/priceHelpers'

import heroImg from './compliance.jpg'
import styles from './Compliance.module.scss'

const SidebarModule = ({ title, children, Icon }) => {
  return (
    <div className={styles.sidebarModule}>
      <div className={styles.sidebarModuleHeader}>
        {Icon && <Icon />}
        <h3>{title}</h3>
      </div>
      <div className={styles.sidebarModuleContent}>{children}</div>
    </div>
  )
}

const Compliance = () => {
  const isInternalAdmin = useInternalAdmin()

  const [isOptInChartVisible, setisOptInChartVisible] = useState(false)
  const [isOptOutChartVisible, setisOptOutChartVisible] = useState(false)

  const [isUploadOptInListDialogVisible, setIsUploadOptInListDialogVisible] = useState()
  const [isUploadOptOutListDialogVisible, setIsUploadOptOutListDialogVisible] = useState()

  const [isDataReady, setIsDataReady] = useState(false)

  const [optedInGuests, setOptedInGuests] = useState()
  const [optInRate, setOptInRate] = useState()

  const [optedOutGuests, setOptedOutGuests] = useState()
  const [optOutRate, setOptOutRate] = useState()

  const [termsUrl, setTermsUrl] = useState()
  const [privacyUrl, setPrivacyUrl] = useState()

  const [isUpdateLegalLinksDialogVisible, setisUpdateLegalLinksDialogVisible] =
    useState(false)

  const [refreshToken, setRefreshToken] = useState(0)

  const [isUploadLogsVisible, setIsUploadLogsVisible] = useState(false)

  useEffect(() => {
    complianceApi.stats().then(res => {
      if (res.totalSubscription) {
        setIsDataReady(true)
        setOptedInGuests(res.totalOptedIn)
        setOptInRate(res.optInRatio)
        setOptedOutGuests(res.totalOptedOut)
        setOptOutRate(res.optedOutRatio)
        setTermsUrl(res.termsUrl)
        setPrivacyUrl(res.privacyUrl)
      }
    })
  }, [refreshToken])

  return (
    <div className={styles.wrapper}>
      {isUploadLogsVisible && (
        <UploadConsentLogsDialog onClose={() => setIsUploadLogsVisible(false)} />
      )}
      {isUploadOptInListDialogVisible && (
        <UploadConsentListDialog
          onClose={() => setIsUploadOptInListDialogVisible(false)}
          type="optin"
        />
      )}
      {isUploadOptOutListDialogVisible && (
        <UploadConsentListDialog
          onClose={() => setIsUploadOptOutListDialogVisible(false)}
          type="optout"
        />
      )}
      {isUpdateLegalLinksDialogVisible && (
        <UpdateLegalLinksDialog
          onClose={() => setisUpdateLegalLinksDialogVisible(false)}
          onSave={() => {
            setisUpdateLegalLinksDialogVisible(false)
            setRefreshToken(refreshToken + 1)
          }}
          termsUrl={termsUrl}
          privacyUrl={privacyUrl}
        />
      )}
      {isOptInChartVisible && (
        <ComplianceOptInChartDialog onClose={() => setisOptInChartVisible(false)} />
      )}
      {isOptOutChartVisible && (
        <ComplianceOptOutChartDialog onClose={() => setisOptOutChartVisible(false)} />
      )}
      <CustomHeader title="Compliance" width={1000} />
      <div className={styles.main}>
        <div className={styles.heroImage}>
          <img src={heroImg} alt="Compliance" />
        </div>
        <div className={styles.complianceInfo}>
          <h1>
            Directful takes care of privacy compliances, <br /> so you don't have to.
          </h1>
          <p>
            Directful operates in complete compliance with all Data Privacy, TCPA, and FCC
            guidelines (which include FTC and State DNC List Compliance). Every guest
            record is analyzed and verified against a 360 degree compliance check,
            gauranteeing compliance for both Directful and Directful customers in respect
            to Directful platform and practices.
          </p>
          <div className={styles.complianceInfoLinks}>
            <a
              href="https://directful.com/privacy-and-sms-compliance-guide/"
              target="_blank"
              rel="noreferrer"
            >
              <PopupIcon /> Learn more about Directful privacy practices
            </a>
            <a href="/directful-privacy-compliance.pdf" target="_blank" rel="noreferrer">
              <DownloadIcon /> Download our compliance sheet
            </a>
          </div>
        </div>
        <div className={styles.additionalComplianceInfo}>
          <h2>What is your responsibility?</h2>
          <p>
            As a platform, Directful makes every effort to keep you compliant. However,
            there are certain areas where you are responsible for ensuring that your
            business remains compliant by taking care of a few simple items. These items
            are as follows:
          </p>
          <ol>
            <li>You ability to upload a "do not call" list.</li>
            <li>You ability to upload an express written consent list.</li>
            <li>
              You ability to change a customer's status to "Consent Given" (also known as
              opt-in) or "Do Not Call" (also known as opt-out).
            </li>
            <li>
              You ability to message any individual on an individual basis (i.e., direct
              messages) regardless if the customer is on do not call list or not.
            </li>
          </ol>
          <p>
            The platform will provide warnings regarding these actions, but ultimately,
            you are the decision maker in whether or not to message or call the customer,
            based on their interests and approval, and with honesty.
          </p>
          <p>
            In situations where the legality of an action is unclear, the system will
            automatically record your actions for future reference.
          </p>
        </div>
      </div>
      {isDataReady && (
        <div className={styles.sidebar}>
          {isInternalAdmin && (
            <SidebarModule title="Guest statistics" Icon={GuestComplianceIcon}>
              <div className={styles.sidebarSubSection}>
                <p className={styles.sidebarSubtitle}>Express written consent</p>
                <div className={styles.sidebarStats}>
                  <div className={styles.sidebarStat}>
                    <p className={styles.sidebarStatNumber}>
                      {formatNumberAsThousands(optedInGuests)}
                    </p>
                    <p className={styles.sidebarStatLabel}>opted-in guests</p>
                  </div>
                  <div className={styles.sidebarStat}>
                    <p className={styles.sidebarStatNumber}>{optInRate}%</p>
                    <p className={styles.sidebarStatLabel}>opted-in rate</p>
                  </div>
                </div>
                <button
                  className={styles.statsChartButton}
                  onClick={() => setisOptInChartVisible(true)}
                >
                  <BarChartIcon />
                  See opt-in rate over time
                </button>
              </div>
              <div className={styles.sidebarSubSection}>
                <p className={styles.sidebarSubtitle}>Do not call</p>
                <div className={styles.sidebarStats}>
                  <div className={styles.sidebarStat}>
                    <p className={styles.sidebarStatNumber}>
                      {formatNumberAsThousands(optedOutGuests)}
                    </p>
                    <p className={styles.sidebarStatLabel}>opted-out guests</p>
                  </div>
                  <div className={styles.sidebarStat}>
                    <p className={styles.sidebarStatNumber}>{optOutRate}%</p>
                    <p className={styles.sidebarStatLabel}>opted-out rate</p>
                  </div>
                </div>
                <button
                  className={styles.statsChartButton}
                  onClick={() => setisOptOutChartVisible(true)}
                >
                  <BarChartIcon />
                  See opt-out rate over time
                </button>
              </div>
            </SidebarModule>
          )}
          <SidebarModule title="Compliance controls" Icon={ControlsIcon}>
            <div className={styles.sidebarSubSection}>
              <p className={styles.sidebarSubtitle}>Upload your lists</p>
              <div className={styles.uploadListControl}>
                <p className={styles.uploadListControlLabel}>Guests with consent</p>
                <button
                  className={styles.uploadListControlButton}
                  onClick={() => setIsUploadOptInListDialogVisible(true)}
                >
                  <FileUploadIcon />
                  Upload
                </button>
              </div>
              <div className={styles.uploadListControl}>
                <p className={styles.uploadListControlLabel}>“Do not call” list</p>
                <button
                  className={styles.uploadListControlButton}
                  onClick={() => setIsUploadOptOutListDialogVisible(true)}
                >
                  <FileUploadIcon />
                  Upload
                </button>
              </div>
              <button
                className={styles.statsChartButton}
                onClick={() => setIsUploadLogsVisible(true)}
              >
                See past uploads
              </button>
            </div>
            <div className={styles.sidebarSubSection}>
              <p className={styles.sidebarSubtitle}>Terms of use</p>
              <a
                href={termsUrl}
                target="_blank"
                rel="noopener  
               noreferrer"
                className={styles.legalUrl}
              >
                {termsUrl}
              </a>
              <div className={styles.legalControls}>
                <button onClick={() => setisUpdateLegalLinksDialogVisible(true)}>
                  <EditIcon />
                  Update link
                </button>
              </div>
            </div>
            <div className={styles.sidebarSubSection}>
              <p className={styles.sidebarSubtitle}>Privacy policy</p>
              <a
                href={privacyUrl}
                target="_blank"
                rel="noopener  
               noreferrer"
                className={styles.legalUrl}
              >
                {privacyUrl}
              </a>{' '}
              <div className={styles.legalControls}>
                <button onClick={() => setisUpdateLegalLinksDialogVisible(true)}>
                  <EditIcon />
                  Update link
                </button>
              </div>
            </div>
          </SidebarModule>
        </div>
      )}
    </div>
  )
}

export default Compliance
